import React from 'react';

// Antd
import { Card, Input, Table, Select, Space } from 'antd';

// Icons
import { Search } from 'react-feather';

// Types
import { TODO, Category } from '../types';

const { Option } = Select;

interface TableCardProps {
  checkboxSelection?: boolean;
  columns: TODO;
  dataSource: TODO;
  title: React.ReactNode;
  categories?: Array<Category>;
  showCardActions?: boolean;
  tableRowKey?: string;
}

export default function TableCard(props: TableCardProps) {
  const [pageSize, setPageSize] = React.useState(50);
  const [searchQuery, setSearchQuery] = React.useState('');

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.name === 'Disabled User', // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <Card
      bodyStyle={{ padding: 0 }}
      title={props.title}
      extra={
        props.showCardActions !== false ? (
          <Space>
            <Input
              placeholder="Search..."
              prefix={<Search />}
              size="large"
              onChange={(e) => {
                setSearchQuery(e.target.value);
              }}
              value={searchQuery}
            />

            {props.categories && props.categories.length > 0 && (
              <Select
                size="large"
                style={{ width: 200 }}
                defaultValue={props.categories[0].detailTypeDisplayName}
              >
                {props.categories.map((account) => (
                  <Option value={account.id} key={account.id}>
                    {account.detailTypeDisplayName}
                  </Option>
                ))}
              </Select>
            )}
            <Select
              defaultValue="Per page: 50"
              size="large"
              onChange={(value: string) => {
                setPageSize(parseInt(value));
              }}
            >
              <Option value="50">Per page: 50</Option>
              <Option value="100">Per page: 100</Option>
              <Option value="500">Per page: 500</Option>
              <Option value="9999">Per page: All</Option>
            </Select>
          </Space>
        ) : undefined
      }
    >
      <Table
        columns={props.columns}
        dataSource={
          searchQuery
            ? props.dataSource.filter(
                (d: TODO) =>
                  `${d.fromName} ${d.toName} ${d.priceSource} ${d.type} ${d.symbol}`
                    .toLowerCase()
                    .indexOf(searchQuery.toLowerCase()) !== -1,
              )
            : props.dataSource
        }
        rowSelection={
          props.checkboxSelection
            ? {
                type: 'checkbox',
                ...rowSelection,
              }
            : undefined
        }
        rowKey={props.tableRowKey}
        pagination={{
          pageSize,
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
        // sticky
        // scroll={{ x: 1500, y: "100vh" }}
      />
    </Card>
  );
}
